import styles from './ShoppingItem.module.css';
import { Link } from 'react-router-dom';

import { FaAngleLeft, FaAngleRight, FaTrash } from 'react-icons/fa';

import { useShoppingCart } from '../../context/ShoppingCartContext';
import storeProducts from '../../data/products.json';

function ShoppingItem({id, quantity}) {
    const { increaseCartQuantity, decreaseCartQuantity, removeFromCart } = useShoppingCart();
    const item = storeProducts.filter(item => item.id === id)[0];
    if (item == null) return null;

    return(
        <div className={styles.container}>
            <Link to={'/product/' + item.id} className={styles.item_link}>
                <div className={styles.image_container}>
                    <img src={item.imgUrl} className={styles.item_image} alt="" />
                </div>
            </Link>
            <div className={styles.item_info}>
                <Link to={'/product/' + item.id} className={styles.item_link}>
                    <span className={styles.item_name}>
                        <p title={item.name}>{item.name}</p>
                    </span>
                </Link>
                <div className={styles.item_control}>
                    <div className={styles.item_quantity}>
                        <span className={styles.item_price}>
                            <p>R$ {(Math.round(item.price * 100) / 100).toFixed(2)}</p>
                        </span>
                        <button className={styles.control_button} onClick={() => decreaseCartQuantity(id)}>
                            <FaAngleLeft/>
                        </button>
                        <p>{quantity}</p>
                        <button className={styles.control_button} onClick={() => increaseCartQuantity(id)}>
                            <FaAngleRight/>
                        </button>
                    </div>
                    <span className={styles.item_remove}>
                        <button onClick={() => removeFromCart(id)} className={styles.control_button}>
                            <FaTrash/>
                        </button>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default ShoppingItem;